import React, { useState, useRef, useEffect } from "react";
import { Image } from "react-bootstrap";
import "../../../styles/containers/CommunicationContainer.scss";
import {
  ManageCommunicationLayout,
  Link,
  LoaderWrapper,
} from "../../../components";
import {
  MANAGE_COMMUNICATION_ROUTES,
  getPathWithParam,
  FLOW_TYPES,
} from "../../../utils";
import { useRouterParams } from "../../../abstracts";
import { CommunicationHistorySlider } from "../CommunicationHistoryContainer/CommunicationHistorySlider";
import { getSentCommunicationDetailsById } from "../../../services";
const CommunicationHistoryInfoContainer = () => {
  const { flow, communicationNameId } = useRouterParams();
  const [isTabSlider, setIsTabSlider] = useState(false);
  const [mailData, setMailData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const values = useRef({});
  // const emaildata = [
  //   { emailAddress: "David@xyz.com", name: "David Beck" },
  //   { emailAddress: "David@xyz123.com", name: "David Abc" },
  // ];
  const customBreadCrumbs = [
    {
      label: "Communication History",
      link: MANAGE_COMMUNICATION_ROUTES.COMMUNICATION_HISTORY_INFO,
    },
  ];
  const button = [
    {
      link: getPathWithParam({
        path: MANAGE_COMMUNICATION_ROUTES.COMMUNICATION_HISTORY,
      }),
      label: "Back",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.VIEW],
    },
  ];

  // const { response: values } = useRequest({
  //   method: getSentCommunicationDetailsById,
  //   payload: 1,
  //   defaultResponse: [],
  // });
  useEffect(() => {
    setIsLoading(true);
    getSentCommunicationDetailsById(parseInt(communicationNameId, 10)).then(
      (response) => {
        values.current = response;
        setIsLoading(false);
      }
    );
  }, []);

  return (
    <ManageCommunicationLayout
      pageName="Communication History Info"
      customBreadCrumbs={customBreadCrumbs}
      buttons={button}
      pageFlow={flow}
    >
      <LoaderWrapper isLoading={isLoading}>
        <div>
          <div className="mb-25">
            <p className="grey ft-12">Communication name</p>
            <p className="bl ft-14">{values.current.communicationName}</p>
          </div>
          <div className="mb-25">
            <p className="grey ft-12">Communication description</p>
            <p className="bl ft-14">
              {values.current.communicationDescription}
            </p>
          </div>
          <div className="mb-25">
            <p className="grey ft-12">Send date and time</p>
            <p className="bl ft-14">{values.current.deliveredDate}</p>
          </div>
          <div className="mb-25">
            <p className="grey ft-12">Send to </p>
            {values.current?.sentTo && values.current?.sentTo.length > 0 ? (
              <p className="bl ft-14">
                {values.current.sentTo[0]}
                {values.current.sentTo.length > 1 ? (
                  <>
                    <Link
                      style={{ color: "#307BF6" }}
                      onClick={() => {
                        setIsTabSlider(true);
                        setMailData(values.current.sentTo);
                      }}
                    >
                      {` + ${values.current.sentTo.length - 1} more `}
                    </Link>
                  </>
                ) : (
                  ""
                )}
              </p>
            ) : (
              "-"
            )}
          </div>
          <div className="mb-25">
            <p className="grey ft-12">CC</p>
            {values.current?.cc && values.current?.cc.length > 0 ? (
              <p className="bl ft-14">
                {values.current.cc[0]}
                {values.current.cc.length > 1 ? (
                  <>
                    <Link
                      style={{ color: "#307BF6" }}
                      onClick={() => {
                        setIsTabSlider(true);
                        setMailData(values.current.cc);
                      }}
                    >
                      {` + ${values.current.cc.length - 1} more `}
                    </Link>
                  </>
                ) : (
                  ""
                )}
              </p>
            ) : (
              "-"
            )}
          </div>
          <div className="mb-25">
            <p className="grey ft-12">Communication</p>
            <div style={{ paddingBottom: "50px" }}>
              <Image
                src={values.current.htmlImagePath}
                // width="573"
                // height="640"
                style={{ border: "0.5px solid #AEABAB" }}
              />
            </div>
          </div>
        </div>

        <CommunicationHistorySlider
          tableData={mailData}
          isSliderOpen={isTabSlider}
          setSliderOpen={setIsTabSlider}
        />
      </LoaderWrapper>
    </ManageCommunicationLayout>
  );
};
export default CommunicationHistoryInfoContainer;
